import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE } from "@/data/site";

export const PhoneLink = ({ className = "", testId = "phone-link", children }) => (
  <a href={`tel:${SITE.tel}`} className={className} data-testid={testId}>
    {children || (
      <>
        <Phone className="h-4 w-4" aria-hidden="true" /> {SITE.phone}
      </>
    )}
  </a>
);

export const Btn = ({ to, variant = "yellow", size, children, testId, arrow = true, className = "" }) => (
  <Link to={to} className={`btn btn-${variant} ${size === "lg" ? "btn-lg" : ""} group ${className}`} data-testid={testId}>
    {children}
    {arrow && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />}
  </Link>
);

export const SectionHead = ({ eyebrow, title, text, light, className = "", align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
    {eyebrow && <p className={`eyebrow ${light ? "text-[#F2C200]" : "text-[#5a4a33]"}`}>{eyebrow}</p>}
    <h2 className={`h2 mt-4 ${light ? "text-white" : "text-[#111]"}`}>{title}</h2>
    {text && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-zinc-300" : "text-[#444]"}`}>{text}</p>}
  </div>
);
